export const CUSTOM_DISTRICT_TYPES = {
  SchoolDistrict: 'School District',
  CityCouncil: 'City Council',
  ANC: 'Advisory Neighborhood District',
  CountyCouncil: 'County Council',
  CountyCommissioner: 'County Commissioner',
  JusticeOfThePeace: 'Justice of the Peace'
};

export const CUSTOM_DISTRICT_MAPPINGS = {
  AR: {
    [CUSTOM_DISTRICT_TYPES.SchoolDistrict]: {
      fieldName: 'customdistricttype7',
      fieldValue: 'customdistrictvalue7'
    },
    [CUSTOM_DISTRICT_TYPES.CityCouncil]: {
      fieldName: 'customdistricttype10',
      fieldValue: 'customdistrictvalue10'
    },
    [CUSTOM_DISTRICT_TYPES.JusticeOfThePeace]: {
      fieldName: 'customdistricttype1',
      fieldValue: 'customdistrictvalue1'
    }
  },
  NM: {
    [CUSTOM_DISTRICT_TYPES.SchoolDistrict]: {
      fieldName: 'customdistricttype2',
      fieldValue: 'customdistrictvalue2',
    },
    [CUSTOM_DISTRICT_TYPES.CityCouncil]: {
      fieldName: 'customdistricttype4',
      fieldValue: 'customdistrictvalue4',
    },
    [CUSTOM_DISTRICT_TYPES.CountyCouncil]: {
      fieldName: 'customdistricttype1',
      fieldValue: 'customdistrictvalue1',
    },
    [CUSTOM_DISTRICT_TYPES.SchoolBoard]: {
      fieldName: 'customdistricttype7',
      fieldValue: 'customdistrictvalue7',
    },
  },
  DC: {
    [CUSTOM_DISTRICT_TYPES.ANC]: {
      fieldName: 'customdistricttype2',
      fieldValue: 'customdistrictvalue2',
    },
  },
  UT: {
    [CUSTOM_DISTRICT_TYPES.CityCouncil]: {
      fieldName: 'customdistricttype3',
      fieldValue: 'customdistrictvalue3',
    },
    [CUSTOM_DISTRICT_TYPES.SchoolBoard]: {
      fieldName: 'customdistricttype2',
      fieldValue: 'customdistrictvalue2',
    },
    // Salt Lake, Summit and Tooele county council districts share this slot, though the file
    // labels it "Salt Lake County Council Districts".
    [CUSTOM_DISTRICT_TYPES.CountyCouncil]: {
      fieldName: 'customdistricttype4',
      fieldValue: 'customdistrictvalue4',
    },
  },
  TX: {
    [CUSTOM_DISTRICT_TYPES.CountyCommissioner]: {
      fieldName: 'customdistricttype1',
      fieldValue: 'customdistrictvalue1',
    },
    [CUSTOM_DISTRICT_TYPES.CityCouncil]: {
      fieldName: 'customdistricttype4',
      fieldValue: 'customdistrictvalue4',
    },
    [CUSTOM_DISTRICT_TYPES.SchoolDistrict]: {
      fieldName: 'customdistricttype5',
      fieldValue: 'customdistrictvalue5',
    },
  },
  CA: {
    [CUSTOM_DISTRICT_TYPES.CountyCommissioner]: {
      fieldName: 'customdistricttype6',
      fieldValue: 'customdistrictvalue6',
    },
  },
  OK: {
    [CUSTOM_DISTRICT_TYPES.CountyCommissioner]: {
      fieldName: 'customdistricttype1',
      fieldValue: 'customdistrictvalue1',
    },
  },
  SD: {
    [CUSTOM_DISTRICT_TYPES.CountyCommissioner]: {
      fieldName: 'customdistricttype2',
      fieldValue: 'customdistrictvalue2'
    }
  },
  MN: {
    [CUSTOM_DISTRICT_TYPES.CityCouncil]: {
      fieldName: 'customdistricttype1',
      fieldValue: 'customdistrictvalue1'
    },
    [CUSTOM_DISTRICT_TYPES.SchoolDistrict]: {
      fieldName: 'customdistricttype2',
      fieldValue: 'customdistrictvalue2'
    },
    [CUSTOM_DISTRICT_TYPES.CountyCommissioner]: {
      fieldName: 'customdistricttype4',
      fieldValue: 'customdistrictvalue4'
    }
  },
  RI: {
    [CUSTOM_DISTRICT_TYPES.CityCouncil]: {
      fieldName: 'customdistricttype1',
      fieldValue: 'customdistrictvalue1'
    }
  }
};

export const getAllowedGeoScopes = (payload) => {
  const data = payload ?? {};
  const {
    'allowed-scope-states': allowedStates,
    'allowed-scope-counties': allowedCounties,
    'allowed-scope-cities': allowedCities,
    'allowed-scope-precincts': allowedPrecincts,
    'allowed-scope-lowerDistricts': allowedLowerDistricts,
    'allowed-scope-lowerSubDistricts': allowedLowerSubDistricts,
    'allowed-scope-upperDistricts': allowedUpperDistricts,
    'allowed-scope-cityCouncils': allowedCityCouncils,
    'allowed-scope-schoolDistricts': allowedSchoolDistricts,
    'allowed-scope-wards': allowedWards,
    'allowed-scope-congressionalDistricts': allowedCongressionalDistricts,
  } = data;

  // Split the string into an array and deduplicate and filter null or undefined values
  const mappedFilters = {
    allowedStates: allowedStates
      ?.split(',')
      .filter((item, index, self) => self.indexOf(item) === index)
      .filter((item) => item),
    allowedCounties: allowedCounties
      ?.split(',')
      .filter((item, index, self) => self.indexOf(item) === index)
      .filter((item) => item),
    allowedCities: allowedCities
      ?.split(',')
      .filter((item, index, self) => self.indexOf(item) === index)
      .filter((item) => item),
    allowedPrecincts: allowedPrecincts
      ?.split(',')
      .filter((item, index, self) => self.indexOf(item) === index)
      .filter((item) => item),
    allowedLowerDistricts: allowedLowerDistricts
      ?.split(',')
      .filter((item, index, self) => self.indexOf(item) === index)
      .filter((item) => item),
    allowedLowerSubDistricts: allowedLowerSubDistricts
      ?.split(',')
      .filter((item, index, self) => self.indexOf(item) === index)
      .filter((item) => item),
    allowedUpperDistricts: allowedUpperDistricts
      ?.split(',')
      .filter((item, index, self) => self.indexOf(item) === index)
      .filter((item) => item),
    allowedCityCouncils: allowedCityCouncils
      ?.split(',')
      .filter((item, index, self) => self.indexOf(item) === index)
      .filter((item) => item),
    allowedSchoolDistricts: allowedSchoolDistricts
      ?.split(',')
      .filter((item, index, self) => self.indexOf(item) === index)
      .filter((item) => item),
    allowedWards: allowedWards
      ?.split(',')
      .filter((item, index, self) => self.indexOf(item) === index)
      .filter((item) => item),
    allowedCongressionalDistricts: allowedCongressionalDistricts
      ?.split(',')
      .filter((item, index, self) => self.indexOf(item) === index)
      .filter((item) => item),
  };

  // Filter out empty arrays
  Object.keys(mappedFilters)?.forEach((key) => {
    if (mappedFilters?.[key] && !mappedFilters?.[key]?.length) {
      delete mappedFilters[key];
    }
  });

  return mappedFilters;
};

export const mapGeoScopesToVotersCombFilters = (geoScopes, filters = {}) => {
  let searchFilters = { ...filters };

  searchFilters._and = searchFilters._and ?? [];
  if (geoScopes?.allowedStates) {
    searchFilters._and.push({
      state: {
        _in: geoScopes?.allowedStates,
      },
    });
  }
  if (geoScopes?.allowedCounties) {
    searchFilters._and.push({
      county: {
        _in: geoScopes?.allowedCounties,
      },
    });
  }
  if (geoScopes?.allowedCities) {
    searchFilters._and.push({
      reg_city: {
        _in: geoScopes?.allowedCities,
      },
    });
  }
  if (geoScopes?.allowedPrecincts) {
    searchFilters._and.push({
      precinct: {
        _in: geoScopes?.allowedPrecincts,
      },
    });
  }
  if (geoScopes?.allowedLowerDistricts) {
    searchFilters._and.push({
      state_leg_lower_district: {
        _in: geoScopes?.allowedLowerDistricts,
      },
    });
  }
  if (geoScopes?.allowedLowerSubDistricts) {
    searchFilters._and.push({
      stateleglowersubdistrict: {
        _in: geoScopes?.allowedLowerSubDistricts,
      },
    });
  }
  if (geoScopes?.allowedUpperDistricts) {
    searchFilters._and.push({
      state_leg_upper_district: {
        _in: geoScopes?.allowedUpperDistricts,
      },
    });
  }
  if (geoScopes?.allowedCityCouncils) {
    const state = geoScopes?.allowedStates?.[0];
    const cityCouncilField =
      CUSTOM_DISTRICT_MAPPINGS[state]?.[CUSTOM_DISTRICT_TYPES.CityCouncil]?.fieldValue;
    if (cityCouncilField) {
      searchFilters._and.push({
        voters_comb_custom_district_new: {
          state: {
            _eq: state,
          },
          [cityCouncilField]: {
            _in: geoScopes?.allowedCityCouncils,
          },
        },
      });
    } else {
      searchFilters._and.push({
        city_council: {
          _in: geoScopes?.allowedCityCouncils,
        },
      });
    }
  }
  if (geoScopes?.allowedSchoolDistricts) {
    const state = geoScopes?.allowedStates?.[0];
    const schoolDistrictField =
      CUSTOM_DISTRICT_MAPPINGS[state]?.[CUSTOM_DISTRICT_TYPES.SchoolDistrict]?.fieldValue;
    if (schoolDistrictField) {
      searchFilters._and.push({
        voters_comb_custom_district_new: {
          state: {
            _eq: state,
          },
          [schoolDistrictField]: {
            _in: geoScopes?.allowedSchoolDistricts,
          },
        },
      });
    } else {
      searchFilters._and.push({
        school_district: {
          _in: geoScopes?.allowedSchoolDistricts,
        },
      });
    }
  }
  if (geoScopes?.allowedWards) {
    searchFilters._and.push({
      ward: {
        _in: geoScopes?.allowedWards,
      },
    });
  }
  if (geoScopes?.allowedJurisnames) {
    searchFilters._and.push({
      jurisname: {
        _in: geoScopes?.allowedJurisnames,
      },
    });
  }

  return searchFilters;
};
